const ENVIRONMENT_OBJECTS_TYPE = {
  Pumpkin: 'PUMPKIN',
  Scarecrow: 'SCARECROW',
  PostSkullLeft: 'POST_SKULL_LEFT',
  PostSkullRight: 'POST_SKULL_RIGHT',
}

export { ENVIRONMENT_OBJECTS_TYPE };
